<form novalidate [formGroup]="form" class="margin-b-1" (appHttpClick)="saveAndUpdate($event)">
  <div fxLayout="row wrap" fxLayoutGap="8px" class="margin-b-1">
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
      <i class="fas fa-save"></i>
      {{'save'|translate}}
    </button>
    <button mat-raised-button type="button" (click)="clear()">
      <i class="fas fa-times"></i>
      {{'clear'|translate}}
    </button>
  </div>
  <mat-expansion-panel style="width: 100%">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ "url" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div fxLayout="row">
      <mat-form-field *ngFor="let controlName of formControlNames" dynamicFlex="100|100|50|50|75">
        <input matInput [formControlName]="controlName" placeholder="{{ controlName | translate }}">
        <mat-error>{{ getErrorMessage(form.get(controlName)) }}</mat-error>
      </mat-form-field>
    </div>
    <!-- ... more content if needed ... -->
  </mat-expansion-panel>

  <mat-expansion-panel style="width: 100%">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ "Login" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div fxLayout="row">
      <mat-form-field>
        <input matInput type="number" [formControlName]="'count'" placeholder="{{ 'count' | translate }}"
          inputmode="numeric">
        <mat-error>{{ getErrorMessage(form.get('count')) }}</mat-error>
      </mat-form-field>
    </div>
    <mat-table [dataSource]="dataSource" class="mat-elevation-z1">
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef>{{ ('id'|translate) }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="username">
        <mat-header-cell *matHeaderCellDef>{{ ('userName'|translate)}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.username}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef>{{ ('count'|translate)}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.count}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="isBlocked">
        <mat-header-cell class="w-5" *matHeaderCellDef>{{'isBlocked'|translate}}
        </mat-header-cell>
        <mat-cell class="w-5" *matCellDef="let element">
          <div fxLayout="row wrap" fxLayoutGap="8px" class="padding-lr-1">
            <i style="color: #d91f34;" class="fas fa-lock clickable margin-tb-1" matTooltip="{{'unblock'|translate}}"
              (click)="unblockUser(element)"></i>
          </div>
        </mat-cell>
      </ng-container>
      <div *matNoDataRow class="bold padding-2 text-center">
        {{'noDataFound'|translate}}
      </div>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <mat-paginator [length]="userPage.totalElements" [pageSize]="userPage.size" [pageIndex]="userPage.number"
      [pageSizeOptions]="CONFIG.PAGE_SIZE_OPTIONS" (page)="getUsers($event)" showFirstLastButtons>
    </mat-paginator>
  </mat-expansion-panel>
</form>